import { Modal, Tabs } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { fairnessModalModel } from '../../model';
import { FairnessModalInfo } from '../fairness-modal-info';
import { FairnessModalVerify } from '../fairness-modal-verify';
import cls from './fairness-modal.module.scss';

export type FairnessModalProps = {
	targetId: string;
};

export const FairnessModal = ({ targetId }: FairnessModalProps) => {
	const { t } = useTranslation();
	const { active, disable } = useUnit(fairnessModalModel.switcher);
	const mounted = useMounted();
	const sm = useBreakpoint('sm', false);

	return (
		mounted && (
			<Modal
				opened={active}
				classNames={{
					overlay: cls.fairnessModalOverlay,
					inner: cls.fairnessModalInner,
					content: cls.fairnessModalContent,
					body: cls.fairnessModalBody,
				}}
				title={t('fairness-modal.title')}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				size={sm ? 'md' : 'sm'}
				onClose={disable}
			>
				<Tabs
					size={sm ? 'md' : 'sm'}
					defaultValue='info'
					keepMounted={false}
					className={cls.fairnessModalTabs}
				>
					<Tabs.List
						grow
						className={cls.fairnessModalTabsList}
					>
						<Tabs.Tab
							className={cls.fairnessModalTabsTab}
							value='info'
						>
							{t('fairness-modal.info.title')}
						</Tabs.Tab>
						<Tabs.Tab
							className={cls.fairnessModalTabsTab}
							value='verify'
						>
							{t('fairness-modal.verify.title')}
						</Tabs.Tab>
					</Tabs.List>
					<Tabs.Panel
						value='info'
						className={cls.fairnessModalTabsPanel}
					>
						<FairnessModalInfo />
					</Tabs.Panel>
					<Tabs.Panel
						value='verify'
						className={cls.fairnessModalTabsPanel}
					>
						<FairnessModalVerify />
					</Tabs.Panel>
				</Tabs>
			</Modal>
		)
	);
};
